export default "__VITE_ASSET__M56mnDPf__"